import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08342c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my_publish" }
const _hoisted_2 = { class: "list flex-1" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "info-ctn flex-column" }
const _hoisted_5 = {
  key: 0,
  class: "name 已回复"
}
const _hoisted_6 = {
  key: 1,
  class: "name 待回复"
}
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "del" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "问题描述：", -1))
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "del" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "联系方式：", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "del" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "反馈时间：", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "footer_one" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("新增反馈")

import { ref } from "vue"
import ListWithRefreshAndLazyLoad from "@/components/ListWithRefreshAndLazyLoad.vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { feedBackListApi } from "@/api/my" // 接口

export default /*#__PURE__*/_defineComponent({
  __name: 'feedBackList',
  setup(__props) {

const getDataAPI = feedBackListApi
const listRef: any = ref(null)
const list: any = ref([])
const route = useRoute()
const params: any = ref({})
const gotoDetail = (item: any) => {
  console.log(item)
  router.push({ path: "/myFeedBack/detail", query: { id: item.sfid } })
}
const addFeedBack = () => {
  router.push({ path: "/myFeedBack/addFeedBack" })
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ListWithRefreshAndLazyLoad, {
        ref_key: "listRef",
        ref: listRef,
        list: list.value,
        "onUpdate:list": _cache[0] || (_cache[0] = ($event: any) => ((list).value = $event)),
        params: params.value,
        getDataAPI: _unref(getDataAPI),
        offset: "5",
        noDataText: "暂无反馈记录，快去新增反馈吧~"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list-item flex-row",
              key: i,
              onClick: ($event: any) => (gotoDetail(item))
            }, [
              _createElementVNode("div", _hoisted_4, [
                (item.replyStatus == 'reply')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, "已回复"))
                  : (item.replyStatus == 'unreply')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, "待回复"))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", {
                      class: "value",
                      innerHTML: item.problemDetail
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("p", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(item.contactPhone), 1)
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.feedbackTime), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _: 1
      }, 8, ["list", "params", "getDataAPI"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_van_button, {
        color: "#ffcd01",
        type: "primary",
        onClick: addFeedBack
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ])
  ]))
}
}

})